import {NAVIGATION_CLEAR_CONFIG, NAVIGATION_FETCH_CONFIG, NAVIGATION_SET_CONFIG} from './constants';
import {IReduxNavigationState} from '../../@interfaces';

export const fetchNavigationConfig = () => ({type: NAVIGATION_FETCH_CONFIG});
export const setNavigationConfig = (config: Exclude<IReduxNavigationState, 'loaded'>) => ({
	type: NAVIGATION_SET_CONFIG,
	payload: config
});
export const clearNavigationConfig = () => ({type: NAVIGATION_CLEAR_CONFIG});
